import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=faf6ef7a&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=faf6ef7a&prod&scoped=true&lang=scss"
import style1 from "./Admin.vue?vue&type=style&index=1&id=faf6ef7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf6ef7a",
  null
  
)

export default component.exports